import React, { useEffect, useState } from 'react'
import Select, { components } from 'react-select'
import { IFilterOption } from 'interfaces//filterProps'
import { colourStyles } from 'helpers/react-select.helper'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown'
import { faSearch } from '@fortawesome/pro-solid-svg-icons/faSearch'
import styles from './index.module.scss'

interface ISelect {
  options: IFilterOption[]
  selectedOption?: any
  onChange: any
  search?: boolean
  disabled?: boolean
  tags?: boolean
  translations: any
  className?: string
  lazyload?: boolean
  onSearch?: any
  dataTest?: string
}

const OptionFilterSelect: React.FC<ISelect> = ({ options, className = '', tags = false, selectedOption, onChange, search = true, disabled = false, translations, onSearch, dataTest }) => {
  const [data, setData] = useState([] as any)
  const [value, setValue] = useState(null as any)
  const [searchText, setSearch] = useState('')

  useEffect(() => {
    const auxOptions = options.slice() || []
    if (selectedOption && selectedOption.value) {
      const exist = options.find(({ value }) => value === selectedOption.value)
      if (!exist && selectedOption.value) {
        const auxData = data.find(({ value }: any) => value === selectedOption.value)
        auxData && auxOptions.push(auxData)
      }
    }
    setData(auxOptions)
  }, [options])

  useEffect(() => {
    let result = selectedOption || null
    if (result && !Array.isArray(result) && !result.value) result = null
    if (tags) result = (result && result) || []
    if (result && result.value) {
      const exist = data.find(({ value }: any) => value === result.value)
      if (exist) result = exist
    }
    setValue(result)
  }, [selectedOption])

  const colorProps: { styles?: any } = {}
  if (tags && data) colorProps.styles = colourStyles

  const handleChange = (data: any) => onChange(data)

  useEffect(() => {
    let timer = null as any
    if (onSearch) {
      timer = setTimeout(() => {
        if (searchText.trim().length >= 1) onSearch(searchText)
      }, 500)
    }
    return () => clearTimeout(timer)
  }, [searchText])

  const DropdownIndicator = (props: any) => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <FontAwesomeIcon className={styles.dropdownIndicator} icon={!!search && props.selectProps.menuIsOpen ? faSearch : faChevronDown} />
        </components.DropdownIndicator>
      )
    )
  }

  return (
    <Select
      className={`${styles.select} ${className} rankmiTable-select`}
      classNamePrefix="rankmiTable-select"
      components={{ DropdownIndicator }}
      data-testid={dataTest}
      isClearable={false}
      isDisabled={disabled}
      isMulti={tags}
      isSearchable={search}
      menuPosition="fixed"
      name="option"
      noOptionsMessage={() => ''}
      options={data}
      placeholder={!disabled ? translations.inputPlaceholder : ''}
      value={!disabled && value}
      onChange={(data: any) => handleChange(tags && !Array.isArray(data) ? [] : data)}
      onInputChange={(text: any) => setSearch(text)}
      {...colorProps}
    />
  )
}

export default OptionFilterSelect
